import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useBackoffice } from '../backoffice/useBackoffice';

export const useCompleteTransfer = () => {
  const { developerId } = useBackoffice();
  const { getAccessTokenSilently } = useAuth0();
  const mutation = useMutation({
    mutationKey: ['complete-transfer'],
    mutationFn: async ({ transferId, transferType }: { transferId: string; transferType: string }) => {
      const token = await getAccessTokenSilently();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/customers/transfers/complete`,
        {
          transfer_id: transferId,
          transfer_type: transferType,
        },
        {
          params: {
            consumerId: developerId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    },
  });

  return {
    completeTransfer: mutation.mutateAsync,
    isCompleting: mutation.isPending,
  };
};
